var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState } from "react";
import { formatWinrateDiff } from "../utils/utils";
export var categories = ['Excellent', 'Great', 'Good', 'Inaccuracy', 'Mistake', 'Blunder'];
export var cutoffs = [15, 5, 0, -5, -15, -Infinity];
export var colors = ['#22cde0', '#1cd938', '#468726', '#d4be35', '#cf620e', '#a30000'];
var PerformanceSummary = function (_a) {
    var selectedIndexes = _a.selectedIndexes, setSelectedIndexes = _a.setSelectedIndexes, winrateDiffs = _a.winrateDiffs, title = _a.title;
    var _b = useState(null), hoveredRow = _b[0], setHoveredRow = _b[1];
    var counts = categories.map(function () { return 0; });
    var totals = categories.map(function () { return 0; });
    var categoryIndexes = winrateDiffs.map(function (diff, index) {
        if (diff === 0) {
            return -1;
        }
        for (var i = 0; i < cutoffs.length; i++) {
            if (diff >= cutoffs[i]) {
                counts[i]++;
                totals[i] += diff;
                return i;
            }
        }
        return -1;
    });
    var handleCategoryClick = function (categoryIndex) {
        var newSelectedIndexes = categoryIndexes.map(function (idx, i) { return idx === categoryIndex ? i : -1; }).filter(function (idx) { return idx !== -1; });
        if (newSelectedIndexes.length > 0) {
            if (arraysAreEqual(newSelectedIndexes, selectedIndexes)) {
                setSelectedIndexes([]);
            }
            else {
                setSelectedIndexes(newSelectedIndexes);
            }
        }
    };
    function arraysAreEqual(arr1, arr2) {
        if (arr1.length !== arr2.length)
            return false;
        for (var i = 0; i < arr1.length; i++) {
            if (arr1[i] !== arr2[i])
                return false;
        }
        return true;
    }
    var getRowStyle = function (index) {
        var thisCategoryIndexes = categoryIndexes.reduce(function (acc, currIdx, i) {
            if (currIdx === index)
                acc.push(i);
            return acc;
        }, []);
        var isSelected = arraysAreEqual(thisCategoryIndexes, selectedIndexes) && thisCategoryIndexes.length > 0;
        var baseStyle = {
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            paddingTop: 6,
            paddingBottom: 6,
            paddingLeft: 30,
            paddingRight: 30,
            borderRadius: 2,
            cursor: thisCategoryIndexes.length > 0 ? 'pointer' : 'default',
            transition: 'background-color 0.1s ease',
            backgroundColor: isSelected ? "".concat(colors[index], "50") : 'transparent'
        };
        if (isSelected) {
            return __assign(__assign({}, baseStyle), { backgroundColor: "".concat(colors[index], "50") });
        }
        else {
            return __assign(__assign({}, baseStyle), { backgroundColor: hoveredRow === index ? "".concat(colors[index], "15") : 'transparent' });
        }
    };
    return (React.createElement("div", { style: { width: '100%', height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' } },
        React.createElement("div", { style: { paddingTop: 25, fontSize: 20, fontWeight: 'bold', marginBottom: '10px' } }, title),
        categories.map(function (category, i) { return (React.createElement("div", { key: i, style: getRowStyle(i), onClick: function () { return handleCategoryClick(i); }, onMouseEnter: function () { return setHoveredRow(i); }, onMouseLeave: function () { return setHoveredRow(null); } },
            React.createElement("div", { style: { width: '65%', display: 'flex', justifyContent: 'flex-start', alignItems: 'center', color: colors[i] } }, category),
            React.createElement("div", { style: { width: '35%', display: 'flex', justifyContent: 'space-between', alignItems: 'center' } },
                React.createElement("div", { style: { display: 'flex', justifyContent: 'flex-end', alignItems: 'center', color: colors[i], fontWeight: 600 } }, counts[i]),
                React.createElement("div", { style: { display: 'flex', justifyContent: 'flex-end', alignItems: 'center', color: colors[i], fontSize: 14 } },
                    formatWinrateDiff(totals[i]),
                    "%")))); })));
};
export default PerformanceSummary;
